export default __webpack_public_path__ + "static/SFMono-SemiboldItalic-10eb596e904940cd1aebb2cc6286015c.woff";